import axios from "axios";
import axiosRetry from "axios-retry";
import { APP_INSCRIPCION_FULL, INSCRIPTION_FULL } from "../config/config";
import { clearFormState } from "../utils/formStorage";

const axiosInstance = axios.create({
  baseURL: APP_INSCRIPCION_FULL,
});

axiosRetry(axiosInstance, {
  retries: 2,
  retryDelay: (retryCount) => Math.min(1000 * retryCount, 5000),
  retryCondition: (error) => {
    if (axiosRetry.isNetworkError(error)) return true;
    if (!error.response) return false;
    const status = error.response.status;
    return status === 500 || status === 400 || status === 404;
  },
});

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const sendInscriptionData = async (data, token, onProgress,generateFullPayment) => {
  try {
    if (typeof onProgress === 'function') {
      onProgress("Estamos procesando tu inscripción");
      // Pequeño delay para que el usuario perciba que comenzó el proceso
      await sleep(2000);
    }
    const payload = {
      ...data,
      pagoTotal: !!generateFullPayment,
    };
    clearFormState();

    const response = await axiosInstance.post(
      INSCRIPTION_FULL,
      payload,
      {
        headers: {
          auth: token,
          "Content-Type": "application/json",
        },
      }
    );

    const responseData = response.data;

    if (typeof onProgress === 'function') {
      onProgress("Inscripción procesada. Estamos generando la boleta y enviando el email de confirmación, por favor no cierres esta página...");
    }

    return responseData;
  } catch (error) {
    console.error("Error al enviar datos:", error);
    throw error;
  }
};

export default sendInscriptionData;
